(() => {
  const roles = Object.freeze({
    'europe-33-esim': 'default_europe',
    'europe-esim': 'conditional_europe',
  });

  const roleFor = (handle) => roles[String(handle || '').trim()] || null;
  const isConditional = (handle) => roleFor(handle) === 'conditional_europe';
  const candidateHandle = (candidate) => candidate?.handle || candidate?.entry?.handle || '';

  // Candidates passed here have already proved complete coverage from the
  // normalized coverage asset. Product identity only resolves an overlap; it
  // never decides whether a plan covers an itinerary.
  const suppressConditionalDuplicate = (candidates) => {
    const list = Array.isArray(candidates) ? candidates : [];
    const hasDefaultEurope = list.some((candidate) => roleFor(candidateHandle(candidate)) === 'default_europe');
    return hasDefaultEurope
      ? list.filter((candidate) => roleFor(candidateHandle(candidate)) !== 'conditional_europe')
      : list;
  };

  window.ROAMUNO_CATALOG_ROLES = Object.freeze({
    roles,
    roleFor,
    isConditional,
    candidateHandle,
    suppressConditionalDuplicate,
  });
})();
